import styles from '@/styles/tabbar.module.scss'
import { ReactNode, useRef, useEffect, useState, useCallback } from 'react'

interface TabItem {
  id: number,
  name: string,
  itemWidth?: string; 
  reactNode?: ReactNode
}

interface props {
  activeTab: number;
  tabItemRightMargin?: string;
  tabList: TabItem[];
  onTabChange: (_index: number) => void; // 从父组件传递的回调函数
  recordId?: (_index: number | string) => void; // 记录当前的ID
}

export default function TabBar({ tabList, activeTab, tabItemRightMargin, onTabChange, recordId }: props) {
  const tabRefs = useRef<(HTMLDivElement | null)[]>([])
  const listRef = useRef<HTMLDivElement>(null)
  const [indicatorStyle, setIndicatorStyle] = useState({ left: 0, width: 0 })

  const updateIndicator = useCallback(() => {
    const activeTabEl = tabRefs.current[activeTab]
    const listEl = listRef.current
    if (activeTabEl && listEl) {
      const tabRect = activeTabEl.getBoundingClientRect()
      const listRect = listEl.getBoundingClientRect()
      setIndicatorStyle({
        left: tabRect.left - listRect.left + tabRect.width / 2 - 9,
        width: 18,
      })
    }
  }, [activeTab])

  useEffect(() => {
    updateIndicator()
    window.addEventListener('resize', updateIndicator)
    return () => window.removeEventListener('resize', updateIndicator)
  }, [updateIndicator])

  // 点击切换tab
  const handleTabClick = (index: number, id: number | string) => {
    onTabChange(index) // 调用父组件传递的回调函数
    recordId && recordId(id)
  }
  
  return (
    <div className={styles['tab-box']}>
      <div className={styles['tab-list']} ref={listRef}>
        {
          tabList.map((item: TabItem, index: number) => (
            <div 
              key={index}
              ref={(el) => { tabRefs.current[index] = el }}
              className={`${styles['tab-item']} ${index === activeTab ? styles['active'] : ''}`}
              style={{ 
                width: item.itemWidth ? item.itemWidth : 'auto',
                marginRight: tabItemRightMargin ? tabItemRightMargin : '60px',
               }}
              onClick={() => handleTabClick(index, item.id)}
            >
              {
                item.reactNode
                ?
                <>{item.reactNode}</>
                :
                <div className={styles['tab-name']}>{item.name}</div>
              }
            </div>
          ))
        }
        {
          activeTab > -1 &&
          <div
            className={styles['tab-indicator']}
            style={{ left: `${indicatorStyle.left}px` }}
          />
        }
      </div>
    </div>
  )
}
